// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 4212 ? "d0deef33" : chunkId) + "." + {"1056":"0bc16ffe94394656","4212":"25c3a0ba9a96c554"}[chunkId] + ".js";
};